<template>
  <b-container>
    <b-card class="mb-4">
      <b-row align-v="center">
        <b-col cols="12" md="6" lg="4">
          <label class="mb-2 font-weight-bold">Select Date Range</label>
          <DatePicker
            v-model="dateRange"
            range
            format="YYYY-MM-DD"
            placeholder="Select date range"
            @change="handleDateRangeChange"
            size="sm"
            style="width: 100%"
          />
        </b-col>
        <b-col cols="12" md="6" lg="4" class="mt-3 mt-md-0">
          <b-button
            variant="primary"
            :disabled="!dateRange"
            @click="handleDateRangeChange"
            class="ml-md-2"
          >
            Refresh Reports
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <div class="d-flex justify-content-center mb-1" v-if="isLoading">
      <b-spinner
        variant="success"
        label="Loading..."
        style="width: 3rem; height: 3rem"
      ></b-spinner>
    </div>
    
    <b-alert show variant="info" v-if="!dateRange && !isLoading">
      Please select a date range above to view the reports.
    </b-alert>

    <b-row v-if="dateRange && !isLoading">
      <b-col cols="12">
        <Tracking :data="monthlySpendingData" />
      </b-col>
      <b-col cols="12">
        <ApexDonutChart :data="donutChartData" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Tracking from "./Chart.vue";
import ApexDonutChart from "./ApexDonutChart.vue";
import { BContainer, BRow, BCol, BCard, BButton, BSpinner, BAlert } from "bootstrap-vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BContainer,
    ApexDonutChart,
    BRow,
    Tracking,
    BCol,
    BCard,
    BButton,
    BSpinner,
    BAlert,
    DatePicker
  },
  
  data() {
    const today = new Date();
    return {
      dateRange: [today, today],
      trackingData: [],
      donutChartData: [],
      monthlySpendingData: [],
      FB: null,
      scope: null,
      facebookToken: localStorage.getItem("facebookToken") || null,
      pagePost: [],
      userId: null,
      appId: null,
      isLoading: false
    };
  },
  
  computed: {
    ...mapGetters("reportModule", {
      reportLoading: "loading",
    }),
    
    token() {
      return localStorage.getItem("token") || null;
    }
  },
  
  methods: {
    ...mapActions("reportModule", [
      "getMonthlySpendingByPlatformAction",
    ]),
    
    handleSdkInit({ FB, scope }) {
      this.FB = FB;
      this.scope = scope;
    },
    
    getPostFacebook() {
      let token = this.facebookToken;
      console.log(token);
      const url = process.env.VUE_APP_API_URLv1;
      axios
        .get(
          url + "marketings/facebook/getpagepost?token=" + token
        )
        .then((res) => {
          this.pagePost = res.data.result.data;
          localStorage.setItem("pagePost", JSON.stringify(this.pagePost));
          console.log(this.pagePost);
        });
    },
    
    onLogin(response) {
      console.log(response);
      this.FB.api("/me/accounts", "GET", { fields: "name,access_token" }, (data) => {
        this.facebookToken = data.data[0].access_token;
        localStorage.setItem("facebookToken", this.facebookToken);
        console.log(data);

        if (this.facebookToken) {
          this.getPostFacebook();
        }
      });
      this.FB.api("/me", "GET", { fields: "name" }, (data) => {
        this.userId = data;
      });
    },
    
    getAppId() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.token,
        },
      };
      const url = process.env.VUE_APP_API_URLv1;
      axios
        .get(url + "marketings/facebook/requestappid", config)
        .then((res) => {
          this.appId = res.data.result.token;
        });
    },
    
    async handleDateRangeChange() {
      if (!this.dateRange || !this.dateRange[0] || !this.dateRange[1]) {
        return;
      }

      const dateParams = {
        dateFrom: this.formatDate(this.dateRange[0]),
        dateTo: this.formatDate(this.dateRange[1]),
      };

      try {
        this.isLoading = true;
        await this.fetchReportData(dateParams);
      } catch (error) {
        console.error("Error updating reports:", error);
      } finally {
        this.isLoading = false;
      }
    },
    
    async fetchReportData(dateParams) {
      try {
        const monthlySpendingData = await this.getMonthlySpendingByPlatformAction(dateParams);

        this.monthlySpendingData = monthlySpendingData || [];
      } catch (error) {
        console.error("Error fetching report data:", error);
        throw error;
      }
    },
    
    formatDate(date) {
      return date.toISOString().split("T")[0];
    },

    showToast() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `Welcome ${this.name}`,
          icon: "BellIcon",
          text: "👋 You have successfully logged in!",
          variant: "Success",
        },
      });
    },
  },
  
  async mounted() {
    try {
      this.isLoading = true;
      this.getAppId();
      await this.handleDateRangeChange();
    } catch (error) {
      console.error("Error during initial load:", error);
    } finally {
      this.isLoading = false;
    }
  }
};
</script>